// @flow

/**
 * Chat Stream Service
 * Wraps the existing streamGenerate service with unified event callback interface
 */

import { streamGenerate } from '../../../../services/aiReportsStream';
import { TIMEOUT_MS } from '../constants';

/**
 * Starts a chat stream with unified event handling
 * @param {Object} config - Stream configuration
 * @param {string} config.sessionId - Session/run ID
 * @param {string} config.prompt - User prompt text
 * @param {string} config.reportId - Optional report ID for edit mode
 * @param {Function} config.onEvent - Unified event handler (status, data) => void
 * @param {Function} config.onError - Error handler (message) => void
 * @param {Function} config.onClose - Close handler () => void
 * @returns {Object} Object with cancel function
 */
export async function startChatStream({
  sessionId,
  prompt,
  reportId,
  onEvent,
  onError,
  onClose,
}) {
  if (!sessionId || !prompt) {
    throw new Error('sessionId and prompt are required');
  }

  return await streamGenerate(
    sessionId,
    prompt,
    {
      onCustomEvent: (payload) => {
        const { status, data } = payload || {};
        if (status && typeof onEvent === 'function') {
          onEvent(status, data);
        }
      },
      onError: (message) => {
        if (typeof onError === 'function') {
          onError(message);
        }
      },
      onClose: () => {
        if (typeof onClose === 'function') {
          onClose();
        }
      },
    },
    {
      timeoutMs: TIMEOUT_MS,
      reportId,
    }
  );
}
